import { Application } from '@hotwired/stimulus'

import DatepickerController from './datepicker-controller'
import FileUploadController from './file-upload-controller'
import StateTimezoneController from './state-timezone-controller'
import TimerController from './timer-controller'
import ForCompaniesCarouselController from './for-companies-carousel-controller'
import ConditionCardController from './condition-card-controller'
import ScrollToController from './scroll-to-controller'
import NewsletterController from './newsletter-controller'
import ParallaxController from './parallax-controller'
import TickerController from './ticker_controller'
import MembershipActivationController from './membership-activation-controller'
import DownloadButtonController from './download-button-controller'
import StaggerRevealController from './stagger-reveal-controller'
import TreeGrowingController from './tree-growing-controller'
import RolodexController from './rolodex-controller'
import NpsFormController from './nps-form-controller'
import AutoModalController from './auto-modal-controller'
import LabCompanyToggleController from './lab-company-toggle-controller'
import HubspotFormController from './hubspot-form-controller'

const application = Application.start()

application.register('datepicker', DatepickerController)
application.register('file-upload', FileUploadController)
application.register('state-timezone', StateTimezoneController)
application.register('timer', TimerController)
application.register('for-companies-carousel', ForCompaniesCarouselController)
application.register('condition-card', ConditionCardController)
application.register('scroll-to', ScrollToController)
application.register('newsletter', NewsletterController)
application.register('parallax', ParallaxController)
application.register('ticker', TickerController)
application.register('membership-activation', MembershipActivationController)
application.register('download-button', DownloadButtonController)
application.register('stagger-reveal', StaggerRevealController)
application.register('tree-growing', TreeGrowingController)
application.register('rolodex', RolodexController)
application.register('nps-form', NpsFormController)
application.register('auto-modal', AutoModalController)
application.register('lab-company-toggle', LabCompanyToggleController)
application.register('hubspot-form', HubspotFormController)

application.debug = window.railsEnv && window.railsEnv === 'development'
window.Stimulus = application
